// extracted by mini-css-extract-plugin
module.exports = {"Announcement":"styles_Announcement__t5fOs","text":"styles_text__AqdK9"};